import { render, staticRenderFns } from "./channelAccess.vue?vue&type=template&id=f707cf4c&scoped=true"
import script from "./channelAccess.vue?vue&type=script&lang=js"
export * from "./channelAccess.vue?vue&type=script&lang=js"
import style0 from "./channelAccess.vue?vue&type=style&index=0&id=f707cf4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f707cf4c",
  null
  
)

export default component.exports